var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/proms_end.9ef04c09.png","uri@2x": __webpack_public_path__ + "static/media/proms_end.ca9e6143.png","uri@3x": __webpack_public_path__ + "static/media/proms_end.0d27f9c1.png",
    width: 221,
    height: 220
});